import { useNavigate } from "react-router-dom";
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
const ExamMenu = () => {
    const navigate = useNavigate();

    const handleClick = (destination) => {
        // handleNavClick(destination);
        navigate("/" + destination);
    };
    const handleLogout = () => {
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("user_id");

        navigate("/login");
    }
    return (
        <div>
            <nav className="navbar navbar-light navbar-expand-md justify-content-between">
                <div className="container-fluid">
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target=".dual-nav">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="navbar-collapse collapse dual-nav w-25 order-1 order-md-0">
                        <ul className="navbar-nav">
                            <li className="nav-item logo">
                                <img
                                    className="card-img-top menu-logo"
                                    src="/images/Original.png"
                                    alt="Achieversiq"
                                    onClick={() => handleClick("")}
                                    style={{ cursor: "pointer" }}
                                />
                            </li>
                        </ul>
                    </div>

                    <div className="navbar-collapse collapse dual-nav w-50 order-0 menu-nav justify-content-center">
                        {/* <ul className="nav navbar-nav ml-auto">
                            <li className={`nav-item active`}><a className="nav-link" href="#">Start Test</a></li>
                        </ul> */}
                    </div>

                    <div className="navbar-brand d-block text-center order-2 order-md-1 mx-auto w-25">
                        {/* <a href="https://login.achieversiq.com/" className="menu-login">Log In</a> */}
                        <button className="primary-button btn btn-primary mx-3 custom-shadow" onClick={() => handleLogout("")} >
                            Logout <KeyboardArrowRightRoundedIcon />
                        </button>
                    </div>
                </div>
            </nav>
        </div>
    );
}

export default ExamMenu;